if (!customElements.get('cart-item-quantity')) {
  customElements.define(
    'cart-item-quantity',
    class CartItemQuantity extends HTMLElement {
      constructor() {
        super();

        this.onFocusOut = (event) => {
          if (!event.target.matches('.cart-item__qty-input')) return;
          this.commitQty(event.target);
        };

        this.onKeydown = (event) => {
          if (!event.target.matches('.cart-item__qty-input')) return;
          if (event.key !== 'Enter') return;

          event.preventDefault();
          this.commitQty(event.target);
        };

        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('keydown', this.onKeydown);
      }

      commitQty(input) {
        this.updateInputQuantity(input);
        this.updateCartQuantity(input);        
      }

      updateInputQuantity(input) {
        const key = input.dataset.changeCartKey;
        const currentQty = parseInt(input.dataset.changeCartQty, 10);
        let qty = parseInt(input.value, 10);

        if (Number.isNaN(qty) || qty < 1) {
          input.value = currentQty;
          return;
        }

        const max = parseInt(input.max, 10);
        if (!Number.isNaN(max) && qty > max) {
          qty = max;
          input.value = qty;
        }

        if (qty === currentQty) {
          input.value = currentQty;
          return;
        }
      }

      async updateCartQuantity(input) {
        const key = input.dataset.changeCartKey;
        const currentQty = parseInt(input.dataset.changeCartQty, 10);
        let qty = parseInt(input.value, 10);

        if (!key || Number.isNaN(qty) || qty < 1 || qty === currentQty) return;

        const max = parseInt(input.max, 10);
        if (!Number.isNaN(max) && qty > max) qty = max;

        const url = `${window.routes?.cart_change_url || '/cart/change'}.js`;

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty }),
          });
          const cart = await response.json();

          if (cart.status !== 422) {
            document.dispatchEvent(new CustomEvent('cartUpdated', { detail: cart }));
          } else {
            document.dispatchEvent(new CustomEvent('cartUpdated', { detail: {} }));
            input.value = currentQty;
          }
        } catch {
          input.value = currentQty;
        }
      }
    }
  );
}
